import React from 'react';

const AboutPage = () => (
    <div className="page-content p-4 md:p-6 prose dark:prose-invert max-w-none">
        <h1 className="text-2xl md:text-4xl font-bold text-gray-900 dark:text-cyan-400 mb-4 text-center">About This Project</h1>
        <p>This application is an educational tool designed for radiation oncologists, medical physicists, and trainees in the field of radiation oncology. Its primary goal is to provide a comprehensive, interactive resource for understanding and applying the principles of Stereotactic Ablative Body Radiotherapy (SABR).</p>
        
        <h2>Key Features</h2>
        <ul>
            <li><strong>RTOG Calculators:</strong> Quickly evaluate SABR lung plans against the criteria set by the Radiation Therapy Oncology Group (RTOG) protocols 0813 and 0915.</li>
            <li><strong>Advanced Plan Metrics:</strong> Analyze key conformity indices, MU efficiency, and estimate treatment delivery times to better understand plan quality.</li>
            <li><strong>Education Modules:</strong> A complete curriculum covering the core principles of SABR, from radiobiology to clinical implementation.</li>
            <li><strong>Competency Quiz:</strong> Test your knowledge with an interactive quiz that provides instant feedback and explanations to reinforce learning.</li>
            <li><strong>Institutional Data:</strong> Log in to save and apply your own institutional benchmarks and planning tolerances.</li>
        </ul>

        <h2>About the Project</h2>
        <p>This project was created with the goal of supporting the radiation oncology community by providing free, high-quality educational tools.</p>
        
        <h2>Disclaimer</h2>
        <p>This tool is for educational and research purposes only. It is not a medical device and is not intended for clinical decision-making. All treatment plans must be created and verified by qualified medical professionals according to your local institutional policies.</p>

        {/* --- NEW CONTACT SECTION --- */}
        <h2 className="mt-8">Contact Us</h2>
        <p>For support, feedback, or any other inquiries, please feel free to reach out to us directly at <a href="mailto:support@sabrcalculator.com" className="text-blue-600 dark:text-blue-400 hover:underline">support@sabrcalculator.com</a>.</p>
        {/* --- END OF NEW SECTION --- */}
    </div>
);

export default AboutPage;